import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormsErrorsService } from '../../services/forms-error.service';
import * as  _ from 'lodash';

@Component({
  selector: 'mapfre-auditlib-form-errors-highlighter',
  templateUrl: './form-errors-highlighter.component.html',
  styleUrls: ['./form-errors-highlighter.component.scss']
})
export class FormErrorsHighlighterComponent implements OnInit {

  formErrors;
  currentIndex;
  visible

  private dangerClass = "border-danger"

  constructor(private formsErrorService: FormsErrorsService, private renderer: Renderer2) {
    this.formsErrorService.observer.subscribe(res => {
      this.formErrors = res;
      if (!this.formErrors || _.size(this.formErrors) === 0) {
        this.visible = false;
      }
    })
    this.formsErrorService.observerVisible.subscribe(res => {
      this.visible = res && _.size(this.formErrors) > 0;
      if (this.visible) {
        this.currentIndex = 0;
        this.navigateToCurrent();
      }
    })
  }

  ngOnInit() {
  }


  onBackClick() {
    this.cleanBorder();
    this.calculateNewIndex(-1);
    this.navigateToCurrent();
  }

  onNextClick() {
    this.cleanBorder();
    this.calculateNewIndex(1);
    this.navigateToCurrent();
  }

  calculateNewIndex(offset) {
    if (_.isNull(this.currentIndex) || _.isNaN(this.currentIndex) || _.isUndefined(this.currentIndex)) {
      this.currentIndex = 0;
    }
    this.currentIndex += offset;
    if (this.currentIndex >= _.size(this.formErrors)) {
      this.currentIndex = 0;
    } else if (this.currentIndex < 0) {
      this.currentIndex = _.size(this.formErrors) - 1;
    }
  }

  navigateToCurrent() {
    const itemToScrollTo: any = _.get(this.formErrors, `[${this.currentIndex}].elementRef.nativeElement`) ?
      _.get(this.formErrors, `[${this.currentIndex}].elementRef.nativeElement`) : _.get(this.formErrors, `[${this.currentIndex}].elementRef`);
    const headerOffset = 45;


    if (itemToScrollTo) {
      setTimeout(() => {
        const elementPosition = itemToScrollTo.getBoundingClientRect().top;

        // window.scrollTo({
        //     top: offsetPosition,
        //     behavior: "smooth"
        // });
        itemToScrollTo.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.renderer.addClass(itemToScrollTo, this.dangerClass);
      }, 0)
    }
  }

  cleanBorder() {
    const itemToScrollTo = _.get(this.formErrors, `[${this.currentIndex}].elementRef.nativeElement`) ?
      _.get(this.formErrors, `[${this.currentIndex}].elementRef.nativeElement`) : _.get(this.formErrors, `[${this.currentIndex}].elementRef`);

    if (itemToScrollTo) {
      setTimeout(() => {
        this.renderer.removeClass(itemToScrollTo, this.dangerClass)
      }, 0)
    }
  }

}
